module.exports = __webpack_public_path__ + "assets/media/pay_brand.7f899539.svg";